<template>
  <div class="renderer" v-if="!loading">
    <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
    <!-- <h1 class="title is-3">{{ title }}</h1> -->
    <span id="top"></span>
    <component
      ref="content"
      class="content"
      id="content"
      :is="dynamicComponent"
      @clean="isClean"
      @loaded="loaded"
    />
    <router-link :to="'/course/' + module + '/' + (step - 1)">
      <b-button @click="scrollUp" rounded v-show="step != 1">Prev</b-button>
    </router-link>
    <router-link
      class="next"
      v-if="step !== stepLength"
      :to="'/course/' + module + '/' + (step + 1)"
    >
      <b-button
        @click="updateProgressLocal('step')"
        type="is-primary"
        :disabled="!clean"
        rounded
        >Next</b-button
      >
    </router-link>
    <div v-else class="finish">
      <b-button
        @click="updateProgressLocal('finish')"
        type="is-primary"
        :disabled="!clean"
        rounded
        >Finish module</b-button
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue/dist/vue.js";
import { mapMutations, mapActions } from "vuex";

// Interactives
import ImageSelect from "@/interact/ImageSelect.vue";
import ScaleAging from "@/interact/ScaleAging.vue";
import ScaleGuide from "@/interact/ScaleGuide.vue";
import ScaleAnatomy from "@/interact/ScaleAnatomy.vue";
import ScaleSummerWinter from "@/interact/ScaleSummerWinter.vue";
import VideoPlayer from "@/interact/VideoPlayer.vue";
import StaticImage from "@/interact/StaticImage.vue";
import ScaleTypeMatch from "@/interact/ScaleTypeMatch.vue";

export default {
  name: "Renderer",
  props: ["markdownData", "module", "step", "stepLength"],
  data() {
    return {
      title: null,
      clean: true,
      loading: true,
      dynamicComponent: ""
    };
  },
  created() {
    this.getMarkdownData();
  },
  methods: {
    ...mapActions("course", [
      "updateProgressAction",
      "updateProgressStateAction",
      "setModuleCompleteInStateAction"
    ]),
    ...mapMutations("course", ["updateProgress", "setCurrentStep"]),
    getMarkdownData() {
      const unified = require("unified");
      const markdown = require("remark-parse");
      const remark2rehype = require("remark-rehype");
      const format = require("rehype-format");
      const raw = require("rehype-raw");
      const html = require("rehype-stringify");

      const processor = unified()
        .use(markdown)
        .use(remark2rehype, { allowDangerousHtml: true })
        .use(raw)
        .use(format)
        .use(html);

      const markdownComponent = processor.processSync(this.markdownData)
        .contents;

      this.dynamicComponent = Vue.component("Markdown", {
        components: {
          ImageSelect,
          ScaleAging,
          ScaleGuide,
          ScaleAnatomy,
          VideoPlayer,
          ScaleSummerWinter,
          StaticImage,
          ScaleTypeMatch,
        },
        data() {
          return {
            selectedItem: null
          };
        },
        methods: {
          done(data) {
            this.$emit("clean", data);
          }
        },
        template: `<div> ${markdownComponent} </div>`
      });
      this.loading = false;
    },
    isClean(data) {
      this.clean = true;
      if (this.interactive) {
        this.updateProgress(data);
      } else {
        this.updateProgress();
      }
    },
    loaded() {
      this.loading = false;
    },
    scrollUp() {
      this.$scrollTo("#top", 500, {
        container: ".content-pane",
        force: true,
        cancelable: false
      });
    },
    async updateProgressLocal(which) {
      let data = {
        module: this.module,
        step: this.step,
        data: { answer: 42 }
      };
      console.log(
        this.$store.state.course.progress.progress.modules[this.module - 1]
          .steps[this.step - 1].complete
      );
      if (
        !this.$store.state.course.progress.progress.modules[this.module - 1]
          .steps[this.step - 1].complete
      ) {
        console.log("setting progress...", data);
        await this.updateProgressStateAction(data);
        this.updateProgressAction();
      }
      if (which == "finish") {
        console.log('Setting module complete...')
        await this.setModuleCompleteInStateAction(data);
        await this.updateProgressAction();
        console.log("route to dash");
        this.$store.commit("setCourseActive", false);
        this.$router.push({ path: '/dashboard' })
      }
      this.scrollUp();
    }
  },
  watch: {
    step() {
      this.getMarkdownData();
    }
  }
};
</script>

<style scoped lang="scss">
.renderer {
  position: relative;

  .next,
  .finish {
    float: right;
  }
}
</style>
